import { Http } from 'lib'
import {
  setIsUpdatingResponse,
  reset,
  setIsLoadingResponses,
  UserResponsesManagerAction,
  setUserResponses,
  setResponseLocally,
  setValidationAndTotals
} from './store/Actions'

import { IUserResponses, IResponseUpdateRequestPayload, IResponsesUpdateRequestPayload, IResponsesValue } from 'types'
import IApiResponse from '../../types/IApiResponse'
import apiUrlsAddresses from '../../config/constants/api-urls-addresses'
import ServiceProviderBase from 'lib/ServiceProviderBase'
import { UserResponsesManagerState, userResponsesManagerInitialState } from './store/State'
import userResponsesManagerReducer from './store/Reducer'
import { cloneDeep } from 'lodash'

export class UserResponsesManagerService extends ServiceProviderBase<
  UserResponsesManagerState,
  UserResponsesManagerAction
> {
  constructor() {
    super(userResponsesManagerInitialState)
  }

  reduce(state: UserResponsesManagerState, action: UserResponsesManagerAction): UserResponsesManagerState {
    return userResponsesManagerReducer(state, action)
  }

  reset() {
    this.dispatch(reset())
  }

  async loadUserResponses(): Promise<string | null> {
    this.dispatch(setIsLoadingResponses(true))

    const [response, , requestError] = await Http.get<IApiResponse<IUserResponses>>(apiUrlsAddresses.userResponse.get())

    this.dispatch(setIsLoadingResponses(false))

    if (Boolean(requestError)) {
      return requestError
    }

    this.dispatch(setUserResponses(response.data))

    return null
  }

  async updateResponse(responseUpdatePayload: IResponseUpdateRequestPayload): Promise<string | null> {
    const payload: IResponsesUpdateRequestPayload = {
      responses: [responseUpdatePayload]
    }

    return this.updateResponses(payload)
  }

  undoChanges(snapshot: IResponsesValue) {
    this.dispatch(setResponseLocally(snapshot))
  }

  async updateResponses(responsesPayload: IResponsesUpdateRequestPayload) {
    this.dispatch(setIsUpdatingResponse(true))

    const snapshot = cloneDeep(this.state.userResponses.responses)

    const newResponses = responsesPayload.responses.reduce((acc, item) => {
      return {
        ...acc,
        [item.questionKey]: item.response
      }
    }, {}) as IResponsesValue

    this.dispatch(setResponseLocally(newResponses))

    const [result, , requestError] = await Http.put<IResponsesUpdateRequestPayload, IApiResponse<IUserResponses>>(
      apiUrlsAddresses.userResponse.update(),
      responsesPayload
    )

    this.dispatch(setIsUpdatingResponse(false))

    if (Boolean(requestError)) {
      this.undoChanges(snapshot)
      return requestError
    }

    this.dispatch(setValidationAndTotals(result.data))

    return null
  }
}

let instance: UserResponsesManagerService = null

export default (() => {
  if (!instance) {
    instance = new UserResponsesManagerService()
  }
  return instance
})()
